import { resolveApiPath } from 'client/core/appConfig';

export const ReviewDocumentApi = {
  downloadLink: (opts: { documentId: number; flowId: number }) =>
    resolveApiPath(
      `/flows/${opts.flowId}/review-documents/${opts.documentId}/download`
    )
};
